import { render, staticRenderFns } from "./CategoriaRepresentivaNew.vue?vue&type=template&id=6f3fd2e9&scoped=true&"
import script from "./CategoriaRepresentivaNew.vue?vue&type=script&lang=js&"
export * from "./CategoriaRepresentivaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3fd2e9",
  null
  
)

export default component.exports